import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const PillowSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$pillowSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$pillowSection' });

  return (
    <section id="hp-pillow" className="hp-section pillow-section pillow">
      <div
        className="hp-banner desktop-only"
        data-event-name="bloc_interact"
        data-bloc-name={t('title')}
      >
        <Link href={tLink('pillow')} className="clearfix">
          <div className="ctg-image">
            <picture>
              <source
                data-srcset="/images/homePage/pillowSection/luxury-collection-pillows-mob.jpg"
                media="(max-width: 768px)"
                srcSet="/images/homePage/pillowSection/luxury-collection-pillows-mob.jpg"
              />
              <img
                data-src="/images/homePage/pillowSection/luxury-collection-pillows.jpg"
                alt={t('alt')}
                src="/images/homePage/pillowSection/luxury-collection-pillows.jpg"
                loading="lazy"
                decoding="async"
                fetchPriority="low"
                width="720"
                height="720"
              />
            </picture>
          </div>
          <div className="stack right">
            <h3>{t('title')}</h3>
            <p className="desktop-only">{t('copy')}</p>
            <span className="btn base-btn btn-text">
              <span>{tButton('shopNow')}</span>
            </span>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default PillowSection;
